import React from 'react'
import * as Avatar from '../Avatar'
import { Title } from './Title'
import { Body } from './Body'
import { View, CardViewProps } from './View'

export interface ProfileMatch {
  name: string
  color?: string | null
  avatarUrl?: string
  title: string
  company?: string
  id: string
  onClick?: React.MouseEventHandler<any> | any
}

export interface MatchCardProps extends CardViewProps {
  match: ProfileMatch
}

export const Match: React.FC<MatchCardProps> = ({
  match,
  onClick: handleClick,
  ...view
}) => {
  return (
    <View {...view}>
      <button className="flex text-left cursor-pointer" onClick={handleClick}>
        <div className="mr-2">
          <Avatar.Simple
            color={match.color || ''}
            name={match.name}
            maxInitials={2}
            imageUrl={match.avatarUrl}
          />
        </div>
        <div className="flex flex-col my-auto">
          <Title>{match.name}</Title>
          <Body>{match.title}</Body>
          {match.company?.length ? <Body>{match.company}</Body> : null}
        </div>
      </button>
    </View>
  )
}

Match.displayName = 'Card.Match'
